module.exports = __webpack_public_path__ + "img/图3.451c939e.png";